import { Component } from 'react';
import { connect } from 'react-redux';

import { MANAGERS, NAVIGATIONS } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { SetOpendMenuAction, setOpendMenuAction } from 'store/actions/layoutActions';
import { Layout, RootState, TransitType } from 'types';
import { MapControlsInterface } from 'types/functions';
import { checkDifferent, clone } from 'utils/formHandlers';
import { withRouter } from 'utils/withRouter';

import DrawingMenu from './menus/DrawingMenu';
import FavouritMenu from './menus/FavouritMenu';
import HighlightMenu from './menus/HighlightMenu';
import InspectTransitMenu from './menus/InspectTransitMenu';
import LayersMenu from './menus/LayersMenu';
import PlansMenu from './menus/PlansMenu';
import PlaybackMenu from './menus/PlaybackMenu';
import SearchMenu from './menus/SearchMenu';
import TimeMenu from './menus/TimeMenu';
import System from './system/System';
import SystemConsole from './system/SystemConsole';

// import FormBuilder from './formBuilder';

interface MenuManagerProps {
    layout: Layout;

    setOpendMenuAction: SetOpendMenuAction;
    mode: string;
    transits: TransitType[];

    mapControls: MapControlsInterface;
    navigate: (path: string) => void; // Add navigation prop
}

interface MenuManagerState {
    layout: Layout;
    searchId: string;
    inspectId: string;
    playbackId: string;
}

class MenuManager extends Component<MenuManagerProps, MenuManagerState> {
    constructor(props: MenuManagerProps) {
        super(props);
        this.state = {
            layout: clone(props.layout),
            searchId: '',
            inspectId: '',
            playbackId: '',
        };
    }

    static getDerivedStateFromProps(props: MenuManagerProps, state: MenuManagerState) {
        if (checkDifferent(props.layout, state.layout)) {
            return {
                layout: clone(props.layout),
                inspectId: props.layout.inspectId,
                playbackId: props.layout.playbackId,
                searchId: props.layout.searchId,
                transits: props.transits,
            };
        }

        return null;
    }

    componentDidUpdate(prevProps: Readonly<MenuManagerProps>, prevState: Readonly<MenuManagerState>): void {
        if (checkDifferent(this.state.layout, prevState.layout)) {
            const section =
                Object.keys(this.state.layout.sections).find((section) => this.state.layout.sections[section].state) ||
                'chart';

            if (NAVIGATIONS.includes(section) || MANAGERS.includes(section)) {
                if (!this.state.layout.allowNavigation) {
                    return;
                }

                this.props.navigate(`/${section}`);
            }
        }
    }

    // setActiveTools: SetActiveToolsFunction = (toolNames, toRemove, toKeep, toggle = false, data?: any) => {
    //     const { activeTools } = clone(this.state);

    //     // Ensure `toolNames` is always an array
    //     const tools = Array.isArray(toolNames) ? toolNames : [toolNames];

    //     tools.forEach((tool) => {
    //         if (LANDING_COM.includes(tool)) {
    //             this.props.navigate(`/landing`);
    //         }
    //         if (NAVIGATIONS.includes(tool) || MANAGERS.includes(tool)) {
    //             this.props.navigate(`/${tool}`);
    //         }
    //     });

    //     if (toRemove.includes('menus')) {
    //         toRemove = [
    //             ...toRemove,
    //             ...MENUS.filter((x) => {
    //                 return !tools.includes(x) && !toKeep.includes(x);
    //             }),
    //         ];
    //     }

    //     // Remove tools specified in `toRemove`
    //     toRemove.forEach((x) => {
    //         const index = activeTools.indexOf(x);
    //         if (index > -1) {
    //             activeTools.splice(index, 1);
    //         }
    //     });

    //     // Process each tool in `tools`
    //     tools.forEach((toolName) => {
    //         if (toggle) {
    //             if (activeTools.includes(toolName)) {
    //                 activeTools.splice(activeTools.indexOf(toolName), 1);
    //             } else {
    //                 activeTools.push(toolName);
    //             }
    //         } else {
    //             if (!activeTools.includes(toolName)) {
    //                 activeTools.push(toolName);
    //             }
    //         }
    //     });

    // switch (this.state.mode) {
    //     case 'live':
    //     case 'time':
    //         if (activeTools.includes('measureArea')) {
    //             this.props.mapControls.time?.setDrawingMode('measureAreaMode');
    //         } else if (activeTools.includes('measureLength')) {
    //             this.props.mapControls.time?.setDrawingMode('measureLengthMode');
    //         } else if (activeTools.includes('drawing')) {
    //             this.props.mapControls.time?.setDrawingMode('drawPolygonMode');
    //         } else {
    //             this.props.mapControls.time?.setDrawingMode('pointer');
    //         }
    //         break;
    //     case 'playback':
    //         if (activeTools.includes('measureArea')) {
    //             this.props.mapControls.playback?.setDrawingMode('measureAreaMode');
    //         } else if (activeTools.includes('measureLength')) {
    //             this.props.mapControls.playback?.setDrawingMode('measureLengthMode');
    //         } else if (activeTools.includes('drawing')) {
    //             this.props.mapControls.playback?.setDrawingMode('drawPolygonMode');
    //         } else {
    //             this.props.mapControls.playback?.setDrawingMode('pointer');
    //         }
    //         break;
    //     case 'search':
    //         if (activeTools.includes('measureArea')) {
    //             this.props.mapControls.chart?.setDrawingMode('measureAreaMode');
    //         } else if (activeTools.includes('measureLength')) {
    //             this.props.mapControls.chart?.setDrawingMode('measureLengthMode');
    //         } else if (activeTools.includes('drawing')) {
    //             this.props.mapControls.chart?.setDrawingMode('drawPolygonMode');
    //         } else {
    //             this.props.mapControls.chart?.setDrawingMode('pointer');
    //         }
    //         break;
    //     default:
    //         break;
    // }

    //     // Update state and actions
    //     this.props.setLayoutAction('DEFAULT',activeTools, data);

    //     this.props.setOpendMenuAction(MENUS.filter((x) => activeTools.includes(x)).length >= 1);
    // };

    render() {
        return (
            <>
                <DrawingMenu
                    active={
                        (this.state.layout.sections.chart.menus.drawingMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.drawingMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.drawingMenu.state &&
                            this.state.layout.sections.playback.state)
                    }
                ></DrawingMenu>

                <LayersMenu
                    active={
                        (this.state.layout.sections.chart.menus.layersMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.layersMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.layersMenu.state &&
                            this.state.layout.sections.playback.state)
                    }
                ></LayersMenu>

                <PlansMenu
                    active={
                        (this.state.layout.sections.chart.menus.plansMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections.time.menus.plansMenu.state &&
                            this.state.layout.sections.time.state) ||
                        (this.state.layout.sections.playback.menus.plansMenu.state &&
                            this.state.layout.sections.playback.state) ||
                        (this.state.layout.sections.profile.menus.plansMenu.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></PlansMenu>

                <System active={this.state.layout.sections.system.menus.system.state}></System>
                <SystemConsole active={this.state.layout.sections.system.menus.systemConsole.state}></SystemConsole>

                <PlaybackMenu
                    active={
                        this.state.layout.sections?.playback.menus?.playbackMenu.state &&
                        this.state.layout.sections.playback.state
                    }
                ></PlaybackMenu>

                <TimeMenu
                    active={
                        this.state.layout.sections?.time.menus?.timeMenu.state && this.state.layout.sections.time.state
                    }
                ></TimeMenu>

                {/* <ChartMenu
                    active={
                        this.state.layout.sections?.chart.menus?.chartMenu.state &&
                        this.state.layout.sections.chart.state
                    }
                ></ChartMenu>

                <GridMenu
                    active={
                        this.state.layout.sections?.grid.menus?.gridMenu.state && this.state.layout.sections.grid.state
                    }
                ></GridMenu> */}
                <FavouritMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.searchMenu.state &&
                            this.state.layout.sections?.grid.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.grid.state) ||
                        (this.state.layout.sections?.chart.menus?.searchMenu.state &&
                            this.state.layout.sections?.chart.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.profile.menus?.searchMenu.state &&
                            this.state.layout.sections?.profile.menus?.searchMenu.sections.loadFavourit.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></FavouritMenu>

                <SearchMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.searchMenu.state &&
                            this.state.layout.sections.grid.state &&
                            !this.state.layout.sections?.grid.menus?.searchMenu.sections.loadFavourit.state) ||
                        (this.state.layout.sections?.chart.menus?.searchMenu.state &&
                            this.state.layout.sections.chart.state &&
                            !this.state.layout.sections?.chart.menus?.searchMenu.sections.loadFavourit.state) ||
                        (this.state.layout.sections?.profile.menus?.searchMenu.state &&
                            this.state.layout.sections.profile.state &&
                            !this.state.layout.sections?.profile.menus?.searchMenu.sections.loadFavourit.state)
                    }
                ></SearchMenu>

                <InspectTransitMenu
                    active={
                        (this.state.layout.sections?.chart.menus?.inspectTransitMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.grid.menus?.inspectTransitMenu.state &&
                            this.state.layout.sections.grid.state)
                    }
                ></InspectTransitMenu>

                <HighlightMenu
                    active={
                        (this.state.layout.sections?.grid.menus?.highlightMenu.state &&
                            this.state.layout.sections.grid.state) ||
                        (this.state.layout.sections?.chart.menus?.highlightMenu.state &&
                            this.state.layout.sections.chart.state) ||
                        (this.state.layout.sections?.profile.menus?.highlightMenu.state &&
                            this.state.layout.sections.profile.state)
                    }
                ></HighlightMenu>

                {/* <ProfileMenu
                    active={
                        this.state.layout.sections?.profile.menus?.profileMenu.state &&
                        this.state.layout.sections.profile.state
                    }
                ></ProfileMenu> */}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    layout: state.layout.layout,
    mode: state.layout.mode,
    mapControls: state.map.mapControls,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setOpendMenuAction: bindActionCreators(setOpendMenuAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MenuManager));
